import React from "react";

export default function WhatsAppButton({ phone = "+51983318651" }) {
  const msg = encodeURIComponent(
    "Hola, me gustaría solicitar información sobre los servicios de tesis."
  );
  const href = `https://wa.me/${phone.replace(/[^\d+]/g, "")}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      title="WhatsApp"
      className="
        fixed bottom-6 right-6 z-50
        transition-transform duration-200
        hover:scale-110 active:scale-95
      "
    >
      {/* Solo el icono SVG */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-12 h-12 text-[#25D366] fill-current"
      >
        <path d="M19.11 17.59c-.3-.15-1.77-.87-2.05-.97-.28-.1-.48-.15-.69.15-.2.3-.79.97-.97 1.17-.18.2-.36.22-.66.07-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.47-1.74-1.64-2.04-.17-.3-.02-.47.13-.62.13-.13.3-.33.45-.49.15-.16.2-.27.3-.46.1-.2.05-.36-.02-.51-.07-.15-.69-1.66-.94-2.28-.25-.6-.5-.52-.69-.53l-.59-.01c-.2 0-.51.07-.78.36-.26.28-1 1-1 2.44 0 1.43 1.03 2.82 1.17 3.01.15.2 2.02 3.1 4.89 4.34.68.3 1.2.47 1.61.6.67.21 1.27.18 1.75.11.53-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.18-1.42-.07-.12-.27-.2-.57-.35z"/>
        <path d="M26.75 5.25C23.61 2.1 19.44.38 15 .38 7.02.38.52 6.89.52 14.87c0 2.61.68 5.16 1.98 7.41L.25 31.62l9.58-2.21c2.19 1.2 4.65 1.84 7.16 1.84 7.98 0 14.49-6.51 14.49-14.49.01-4.43-1.71-8.6-4.93-11.76zM15 28.67c-2.32 0-4.58-.62-6.56-1.79l-.47-.28-5.69 1.31 1.21-5.55-.3-.49c-1.22-1.99-1.86-4.28-1.86-6.6C1.33 8.21 7.34 2.2 15 2.2c6.8 0 12.34 5.54 12.34 12.34 0 6.66-5.54 12.13-12.34 12.13z"/>
      </svg>
    </a>
  );
}
